<template>
  <div class="home-dynamic-body">
    <div class="home-dynamic-banner-body">
      <a-carousel autoplay>
        <div
          class="home-dynamic-banner"
          v-for="item in bannerList"
          :key="item.id"
        >
          <v-img
            :attachment-id="item.attachment.attachmentId"
            :default-img="require('@/assets/img/dtbanner.jpg')"
            @click="handleBannerClick(item)"
          ></v-img>
          <!-- <div>
            <p>关于2021年第三季度</p>
            <strong>5G应用场景需求征集通知说明</strong>
            <span>查看详情</span>
          </div> -->
        </div>
      </a-carousel>
    </div>
    <div class="home-dynamic-list-tab">
      <div>
        <p>
          <span
            :class="{ active: newsTypeIndex == index }"
            v-for="(item, index) in newsTypeData"
            :key="item.id"
            @click="newsType(item.id, index)"
            >{{ item.typeName }}</span
          >
        </p>
        <a-input-search
          style="width: 400px"
          placeholder="请输入关键词搜索"
          enter-button
          v-model="dynamicSearchVal"
          @search="onSearch"
        />
      </div>
    </div>
    <div class="home-dynamic-list-content">
      <div
        class="home-dynamic-list"
        @click="dynamicDetail(item.id)"
        v-for="item in newsList"
        :key="item.id"
      >
        <div>
          <p>
<!--            {{ newsTypeIndex == 0 ? "【通知】" : "【政策】" }}-->
            {{ item.newsName }}
          </p>
          <!-- <span class="new">新</span>
          <span class="zd">置</span> -->
        </div>
        <span>{{ item.publishTime | moment("YYYY-MM-DD") }}</span>
      </div>
      <div class="home-dynamic-page">
        <a-pagination
          show-quick-jumper
          :default-page-size="15"
          :page-size-options="pageNum"
          :default-current="page.current"
          :total="page.total"
          :show-total="(total) => `共 ${total} 项`"
          @change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsType, getNewsList, getAdBanner } from "@/api/news";
import VImg from "@/components/VImg";
export default {
  components: { VImg },
  data() {
    return {
      newsTypeData: [],
      newsTypeIndex: 0,
      newsList: [],
      page: {
        size: 15,
        current: 1,
        total: 0,
      },
      pageNum: ["15", "20", "30"],
      newsTypeId: "",
      dynamicSearchVal: "",
      bannerList: [],
    };
  },
  mounted() {
    this.loadGetNewsType();
    this.loadGetAdBanner();
  },
  methods: {
    loadGetNewsType() {
      getNewsType().then((res) => {
        this.newsTypeData = res.data;
        this.newsTypeId = res.data[0].id;
        this.loadGetNewsList();
      });
    },
    loadGetAdBanner() {
      getAdBanner().then((res) => {
        this.bannerList = res.data;
      });
    },
    newsType(type, index) {
      this.newsTypeIndex = index;
      this.newsTypeId = type;
      this.loadGetNewsList();
    },
    loadGetNewsList() {
      let data = {
        type: this.newsTypeId,
        keywords: "",
      };
      getNewsList(this.page, data).then((res) => {
        this.newsList = res.data.records;
        this.page.total = res.data.total;
      });
    },
    pageChange(page) {
      this.page.current = page;
      this.loadGetNewsList();
    },
    onSearch() {
      if (!this.dynamicSearchVal) {
        this.$message.warning("请输入搜索内容");
        return;
      }
      this.$router.push({
        name: "homeDynamicSearch",
        params: {
          search: this.dynamicSearchVal,
        },
      });
    },
    dynamicDetail(id) {
      this.$router.push({
        path: "/homeDynamic/detail",
        query: { id: id },
      });
    },
    handleBannerClick(el) {
      if (el.link) {
        window.open(`${el.link}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-dynamic-body {
  padding-bottom: 40px;
}
.home-dynamic-banner-body {
  height: 320px;
  .home-dynamic-banner {
    position: relative;
    display: block;
    height: 320px;
    > img {
      display: block;
      max-width: 100%;
      height: 100%;
    }
    > div {
      width: 1200px;
      position: absolute;
      left: 50%;
      top: 0;
      bottom: 0;
      margin-left: -600px;
      padding-top: 70px;
      > p {
        font-size: 28px;
        color: #fff;
        font-weight: bold;
        line-height: 28px;
        margin-bottom: 32px;
      }
      > strong {
        display: block;
        font-size: 44px;
        line-height: 44px;
        color: #fff;
        margin-bottom: 39px;
      }
      > span {
        width: 120px;
        height: 32px;
        border: 1px solid #ffffff;
        border-radius: 16px;
        cursor: pointer;
        color: #fff;
        text-align: center;
        line-height: 30px;
        display: block;
      }
    }
  }
}
.home-dynamic-list-tab {
  background: #fff;
  > div {
    width: 1200px;
    margin: 0 auto;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > p {
      display: flex;
      > span {
        height: 56px;
        line-height: 56px;
        border-bottom: 2px solid transparent;
        margin-right: 40px;
        cursor: pointer;
        &.active {
          border-color: #1abc9c;
        }
      }
    }
  }
}
.home-dynamic-list-content {
  width: 1200px;
  background-color: #fff;
  margin: 24px auto 0;
  padding: 0 24px;
  .home-dynamic-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px 0;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    > div {
      display: flex;
      align-items: center;
      > p {
        margin-right: 16px;
        max-width: 600px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      > span {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 16px;
        &.new {
          background: linear-gradient(45deg, #1890ff 0%, #41baff 100%);
        }
        &.zd {
          background: linear-gradient(45deg, #f52222 0%, #ff8b23 100%);
        }
      }
    }
    > span {
      color: #8c8c8c;
    }
  }
}
.home-dynamic-page {
  padding: 24px;
  text-align: right;
}
</style>
<style>
.before-content-body {
  background: #f7f7f7;
}
.ant-btn-primary {
  background-color: #1abc9c !important;
  border-color: #1abc9c !important;
}
</style>
